import { config } from "config";
import { org } from "constants/common";
import AuthService from "services/AuthService";
import { api } from "./Call";
import * as UtilsService from "services/UtilsService";
import { entitiesCache, updateEntityToCache } from "./Cache";

//const org = localStorage.getItem('organizationID');

export default class Utils {
    static serverCreateId = (done: (response: any) => void) => {
        var xmlhttp = new XMLHttpRequest();
        var url = config.api.baseUrl + "/" + config.api.endpoints["file"] + "?generateids=1";

        xmlhttp.onreadystatechange = () => {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    var idList = JSON.parse(xmlhttp.responseText);
                    done(idList[0]);
                } else {
                    console.error("serverCreateId server is down!");
                    done(null);
                }
            }
        };
        xmlhttp.open("GET", url, true);

        const token = AuthService.getToken();
        if (token) {
            const tokenHeader = "Bearer " + token;
            xmlhttp.setRequestHeader("Authorization", tokenHeader);
        }

        xmlhttp.send();
    };

    static validateProgram = function (code: string, ondone: (object: any) => void) {
        var xhr = new XMLHttpRequest();
        var url = config.api.baseUrl + "/" + config.api.endpoints["entity"] + "?program=validate";

        xhr.open("POST", url, true);

        const token = AuthService.getToken();
        if (token) {
            const tokenHeader = "Bearer " + token;
            xhr.setRequestHeader("Authorization", tokenHeader);
        }
        xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");

        xhr.onload = function () {
            if (xhr.readyState === 4)
                if (ondone !== null) {
                    if (xhr.status === 200) {
                        var response = JSON.parse(xhr.responseText);
                        ondone(response);
                    } else {
                        ondone({ result: "error" });
                    }
                }
        };
        try {
            xhr.send(code);
        } catch (err) {
            ondone({ result: "error" });
        }
    };

    static remoteCreateEntity = (
        projectId: string,
        fileFolderId: string,
        name: string,
        fileType: string,
        fields: any = {},
        callback: any
    ) => {
        var body = {
            ...fields,
            name: name,
            type: "FILE",
            file_type: fileType,
            file_date: Date.now(),
            file_folder: fileFolderId,
            project: projectId,
        };
        api(`entity.ashx?project=${projectId}`, { body: body })
            .then((result: any) => {
                //console.log(entries);
                if (result.error_info) {
                    console.error(atob(result.error_info));
                } else {
                    body = { ...body, ID: result.id };
                    updateEntityToCache("entities", projectId, body);
                    callback(result);
                }
            })
            .catch((error: any) => {
                console.error(error);
            });
    };

    static remoteCreateFolder = (
        projectId: string,
        fileFolderId: string,
        folderName: string,
        fields: any = {},
        callback: any
    ) => {
        this.remoteCreateEntity(projectId, fileFolderId, folderName, "FOLDER", fields, callback);
    };

    static remoteCreateProject = function (values: any, ondone: (object: any) => void) {
        var json = JSON.stringify(values);

        var formData = new FormData();
        formData.append("operation", "create");
        formData.append("data", json);

        var xhr = new XMLHttpRequest();
        var url = config.api.baseUrl + "/entity.ashx";
        xhr.open("POST", url, true);
        const token = AuthService.getToken();
        if (token) {
            const tokenHeader = "Bearer " + token;
            xhr.setRequestHeader("Authorization", tokenHeader);
        }

        xhr.onload = function () {
            if (xhr.readyState === 4) {
                if (ondone !== null) {
                    if (xhr.status === 200) {
                        try {
                            //var response = JSON.parse(xhr.responseText);
                            //ondone(response);
                            const responseText = xhr.responseText;
                            if (responseText.includes("success")) {
                                const firstObj = responseText.split("}");
                                var response = JSON.parse(firstObj[0] + "}");
                                ondone(response);
                            }
                        } catch (err: any) {
                            ondone(err);
                        }
                    } else {
                        ondone({ result: "error" });
                    }
                }
            }
        };
        try {
            xhr.send(formData);
        } catch (err) {
            ondone({ result: "error" });
        }
    };

    static remoteProcess = function (projectId: string, id: string, processId: string, callback: any) {
        var formData = new FormData();
        formData.append("process", processId);

        var xhr = new XMLHttpRequest();
        var url =
            config.api.baseUrl +
            "/" +
            config.api.endpoints["event"] +
            "/?project=" +
            projectId +
            "&id=" +
            id +
            "&org=" +
            org;

        xhr.open("POST", url, true);

        const token = AuthService.getToken();
        if (token) {
            const tokenHeader = "Bearer " + token;
            xhr.setRequestHeader("Authorization", tokenHeader);
        }

        xhr.onload = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    try {
                        var response = JSON.parse(xhr.responseText);
                        callback(response);
                    } catch (err: any) {
                        console.error(err.message);
                        callback(err);
                    }
                } else {
                    callback({ error: 418 });
                }
            }
        };
        try {
            xhr.send(formData);
        } catch (err) {
            callback({ error: 418 });
        }
    };

    static attachFileToEntity = (projectId: string, entityId: string, fileName: string, data: any, done: any) => {
        const file = new File([data], fileName);
        this.postFileToServer(
            projectId,
            entityId,
            file,
            0,
            () => {
                console.log("attached entityId:", entityId, "|data:", data);
                done();
            },
            () => {}
        );
    };

    static initializeWorkflow = (
        projectId: string,
        projectName: string,
        programId: string,
        initializeProject: string,
        progressCallback: any,
        done: any
    ) => {
        var progress = 0;
        const fields: any = {
            file_type: "PROCESS",
            code_origin: "PROGRAM",
            code: programId,
            input_value_project: initializeProject,
            input_filter_project: 0,
            input_label_project: 0,
            input_type_project: 0,
            state: "PARTIAL",
        };
        const waitForResult = (result: any) => {
            Utils.getRemoteObjects([result.id], projectId, (entities: any) => {
                if (entities[0]["state"] === "COMPLETE") {
                    done(result);
                } else {
                    progress++;
                    progressCallback(progress);
                    UtilsService.sleep(result.id, waitForResult, 2000, result);
                }
            });
        };
        this.remoteCreateEntity(
            projectId,
            "0",
            "initialize_project_" + projectName,
            "PROCESS",
            fields,
            (response: any) => {
                if (response.result === "success") {
                    var id = response.id;
                    fields["ID"] = id;
                    fields["project"] = projectId;
                    fields["name"] = "initialize_project_" + projectName;
                    updateEntityToCache("entities", projectId, fields);
                    this.remoteProcess(projectId, id, "PROCESS", (result: any) => {
                        result.id = id;
                        waitForResult(result);
                    });
                }
            }
        );
    };

    static postFileToServer = (
        projectId: string,
        itemId: string,
        file: File,
        bytesUploaded: any,
        success: (size: number) => void,
        failure: () => void
    ) => {
        var formData = new FormData();
        formData.append("file", file);
        var xhr = new XMLHttpRequest();
        var url =
            config.api.baseUrl +
            "/" +
            config.api.endpoints["file"] +
            "?project=" +
            projectId +
            "&id=" +
            itemId +
            "&org=" +
            org +
            "&partialsize=" +
            bytesUploaded;
        xhr.open("POST", url, true);

        const token = AuthService.getToken();
        if (token) {
            const tokenHeader = "Bearer " + token;
            xhr.setRequestHeader("Authorization", tokenHeader);
        }

        xhr.onload = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    try {
                        var response = JSON.parse(xhr.responseText);
                        if (response.result === "success") {
                            var size = parseInt(response.size);
                            success(size);
                        } else failure();
                    } catch (err: any) {
                        failure();
                        console.log(err.message);
                    }
                } else {
                    failure();
                }
            }
        };
        try {
            xhr.send(formData);
        } catch (err) {
            console.error(err);
            failure();
        }
    };

    static reprocess = (projectId: string, processEntityId: string, callback: any) => {
        const values: any = {
            state: "PARTIAL",
            partial_progress: "0",
            partial_status: "",
            update_type: "reprocess",
            version_reprocess: "0",
            start_processing_time: Date.now() + "",
        };
        this.remoteUpdateEntity(projectId, processEntityId, values, (result: any) => {
            this.remoteProcess(projectId, processEntityId, processEntityId, (result: any) => {
                callback(result);
            });
        });
    };

    static getProject = (projectId: string) => {
        var url = config.api.endpoints["entity"] + "?id=" + projectId + "&project=" + projectId;
        return api(url);
    };

    static getEntity(id: string, projectId: string, callback: any) {
        if (!id || id === "" || !projectId || projectId === "") {
            callback({});
            return;
        }
        var url = config.api.endpoints["entity"] + "?id=" + id + "&project=" + projectId;
        return api(url).then((entity: any) => {
            if (!entity.error) {
                entitiesCache[entity["ID"]] = entity;
                updateEntityToCache("entities", projectId, entity);
            }
            callback(entity);
        });
    }

    static remoteUpdateEntity = (projectId: string, id: string, values: any, ondone: (result: any) => void) => {
        var json = JSON.stringify(values);
        var xhr = new XMLHttpRequest();
        var url = config.api.baseUrl + "/" + config.api.endpoints["entity"] + "?id=" + id + "&project=" + projectId;
        xhr.open("POST", url, true);

        const token = AuthService.getToken();
        if (token) {
            const tokenHeader = "Bearer " + token;
            xhr.setRequestHeader("Authorization", tokenHeader);
        }
        xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");

        xhr.onload = function () {
            if (xhr.readyState === 4) {
                if (ondone !== null) {
                    if (xhr.status === 200) {
                        var response = JSON.parse(xhr.responseText);
                        ondone(response);
                    } else {
                        ondone({ result: "error" });
                    }
                }
            }
        };
        try {
            xhr.send(json);
        } catch (err) {
            console.error(err);
        }
    };

    static remoteUpdateCollection = function (
        id: string,
        collectionId: string,
        values: any,
        ondone: (result: any) => void
    ) {
        var json = JSON.stringify(values);

        var xhr = new XMLHttpRequest();
        var url = config.api.baseUrl + "/entity.ashx?id=" + id + "&project=" + collectionId;
        xhr.open("POST", url, true);

        const token = AuthService.getToken();
        if (token) {
            const tokenHeader = "Bearer " + token;
            xhr.setRequestHeader("Authorization", tokenHeader);
        }

        xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");
        xhr.onload = function () {
            if (xhr.readyState === 4) {
                if (ondone !== null) {
                    if (xhr.status === 200) {
                        var response = JSON.parse(xhr.responseText);
                        ondone(response);
                    } else {
                        ondone({ result: "error" });
                    }
                }
            }
        };
        try {
            xhr.send(json);
        } catch (err) {
            // TODO: Handle error
        }
    };

    static fetchProgramInputs = function (id: string, done: (object: any) => void) {
        new Promise((resolve, reject) => {
            var url = config.api.baseUrl + config.api.endpoints["entity"] + "?id=" + id + "&program=input";
            api(url)
                .then((entries: any) => {
                    if (done) {
                        done(entries);
                    }
                    resolve(entries);
                })
                .catch((error: any) => {
                    console.error(error);
                    reject(error);
                    done({ result: "error" });
                });
        });
    };

    static fetchProjectEntities = (projectId: string, callback?: any) =>
        new Promise((resolve, reject) => {
            api("entity.ashx?project=" + projectId)
                .then((entries: any) => {
                    if (callback) {
                        callback(entries);
                    }
                    resolve(entries);
                })
                .catch((error: any) => {
                    console.error(error);
                    reject(error);
                });
        });

    static createEntity = function (projectId: string, object: any, callback: any) {
        let body = {
            file_date: new Date().getTime() + "",
            name: "New Version",
            project: projectId,
            state: "COMPLETE",
            file_type: "RAW",
            type: "FILE",
        };

        if (object !== undefined && object !== null) {
            body = { ...body, ...object };
        }

        api(`${config.api.endpoints["entity"]}?project=${projectId}`, { body: body, format: "json" })
            .then((entries: any) => {
                callback(entries);
            })
            .catch((error: any) => {
                callback(null, error);
            });
    };

    static remoteDeleteProject = (projectId: string, userId: string, callback: any) => {
        const user_usersproject_id = "users:" + projectId + ":" + userId;
        const user_usersproject = {
            access_level: "none",
        };

        const user_project_id = projectId + ":" + userId;
        const user_project = {
            access_level: "none",
        };

        const project_user_id = userId + ":" + projectId;
        const project_user = {
            access_level: "none",
        };
        this.remoteUpdateEntity(user_project_id, user_project_id, user_project, (user_project_data: any) => {
            if (user_project_data.result === "success") {
                this.remoteUpdateEntity(
                    user_usersproject_id,
                    user_usersproject_id,
                    user_usersproject,
                    (user_usersproject_data: any) => {
                        if (user_usersproject_data.result === "success") {
                            this.remoteUpdateCollection(
                                project_user_id,
                                userId,
                                project_user,
                                (project_user_data: any) => {
                                    if (project_user_data.result === "success") {
                                        callback();
                                    }
                                }
                            );
                        }
                    }
                );
            }
        });
    };

    static remoteDeleteItems = (
        projectId: string,
        itemList: any,
        success?: (response: any) => void,
        failure?: () => void
    ) => {
        var formData = new FormData();
        formData.append("operation", "delete");
        formData.append("items", itemList);

        var xhr = new XMLHttpRequest();
        var url = config.api.baseUrl + "/" + config.api.endpoints["entity"] + "?project=" + projectId + "&org=" + org;
        xhr.open("POST", url, true);

        const token = AuthService.getToken();
        if (token) {
            const tokenHeader = "Bearer " + token;
            xhr.setRequestHeader("Authorization", tokenHeader);
        }

        xhr.onload = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    try {
                        var response = JSON.parse(xhr.responseText);
                        if (success) {
                            success(response);
                        }
                    } catch (err: any) {
                        if (failure) {
                            failure();
                        }

                        console.log(err.message);
                    }
                } else {
                    if (failure) {
                        failure();
                    }
                }
            }
        };
        try {
            xhr.send(formData);
        } catch (err) {
            if (failure) {
                failure();
            }
            console.error(err);
        }
    };

    static getViewProgramMetaFromCode = function (
        projectId: string,
        code: string,
        inputs: any,
        ondone: (object: any) => void
    ) {
        var values: any = {
            code: code,
            project: projectId,
        };
        for (var input in inputs) {
            values[input] = inputs[input];
        }
        var json = JSON.stringify(values);

        var xhr = new XMLHttpRequest();
        var url = config.api.baseUrl + "/" + config.api.endpoints["entity"] + "?program=viewmeta";
        xhr.open("POST", url, true);

        const token = AuthService.getToken();
        if (token) {
            const tokenHeader = "Bearer " + token;
            xhr.setRequestHeader("Authorization", tokenHeader);
        }
        xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");

        xhr.onload = function () {
            if (xhr.readyState === 4) {
                if (ondone !== null) {
                    if (xhr.status === 200) {
                        var response = JSON.parse(xhr.responseText);
                        ondone(response);
                    } else {
                        ondone({ result: "error" });
                    }
                }
            }
        };
        try {
            xhr.send(json);
        } catch (err) {
            // TODO: Handle error
        }
    };

    static getPlatformVersion = async (callback: any) => {
        let url = config.api.endpoints["file"] + "?action=config";
        return new Promise((resolve, reject) => {
            return api(url)
                .then((data: any) => {
                    callback(data);
                    resolve(data);
                })
                .catch((error: any) => {
                    console.error(error);
                    reject(error);
                });
        });
    };

    static fetchSetNames = (project: string, id: string) => {
        return new Promise((resolve, reject) => {
            const nameHint = "mesh_names.txt";
            const url =
                config.api.endpoints["file"] +
                "?org=" +
                org +
                "&project=" +
                project +
                "&id=" +
                id +
                "&filename=" +
                nameHint +
                "&namehint=" +
                btoa(nameHint);
            return api(url, { format: "text" })
                .then((data: any) => {
                    resolve(data);
                })
                .catch((error: any) => {
                    console.error(error);
                    reject(error);
                });
        });
    };

    static fetchSetConfig = (project: string, id: string) => {
        return new Promise((resolve, reject) => {
            const nameHint = "set_children_properties.txt";
            const url =
                config.api.endpoints["file"] +
                "?org=" +
                org +
                "&project=" +
                project +
                "&id=" +
                id +
                "&filename=" +
                nameHint +
                "&namehint=" +
                btoa(nameHint);
            return api(url, { format: "text" })
                .then((data: any) => {
                    resolve(data);
                })
                .catch((error: any) => {
                    console.error(error);
                    reject(error);
                });
        });
    };

    static getExtendedMeta = (projectId: string, entityId: string) => {
        return new Promise((resolve, reject) => {
            const nameHint = "extended.meta";
            const url =
                config.api.endpoints["file"] +
                "?org=" +
                org +
                "&project=" +
                projectId +
                "&id=" +
                entityId +
                "&filename=" +
                nameHint +
                "&namehint=" +
                btoa(nameHint);
            return api(url, { format: "text" })
                .then((data) => {
                    resolve({ entityId, data });
                })
                .catch((error: any) => {
                    console.error(error);
                    reject(error);
                });
        });
    };

    static fetchAttributes = (projectId: string, layerId: string, entityId: string) => {
        return new Promise((resolve, reject) => {
            const nameHint = "extended.meta";
            const url =
                config.api.endpoints["file"] +
                "?org=" +
                org +
                "&project=" +
                projectId +
                "&id=" +
                entityId +
                "&filename=" +
                nameHint +
                "&namehint=" +
                btoa(nameHint);
            return api(url, { format: "text" })
                .then((data) => {
                    resolve({ layerId, entityId, data });
                })
                .catch((error) => {
                    console.error(error);
                    reject(error);
                });
        });
    };

    static downloadFile = (project: string, id: string, filename: string) => {
        return new Promise((resolve, reject) => {
            const url =
                config.api.endpoints["file"] +
                "?org=" +
                org +
                "&project=" +
                project +
                "&id=" +
                id +
                "&filename=" +
                filename +
                "&namehint=" +
                btoa(filename);
            return api(url, { format: "text" })
                .then((data: any) => {
                    resolve(data);
                })
                .catch((error: any) => {
                    console.error(error);
                    reject(error);
                });
        });
    };

    static fetchReportCSV = (project: string, id: string) => {
        return new Promise((resolve, reject) => {
            const nameHint = "report.csv";
            const url =
                config.api.endpoints["file"] +
                "?org=" +
                org +
                "&project=" +
                project +
                "&id=" +
                id +
                "&filename=" +
                nameHint +
                "&namehint=" +
                btoa(nameHint);
            return api(url, { format: "text" })
                .then((data: any) => {
                    resolve(data);
                })
                .catch((error: any) => {
                    console.error(error);
                    reject(error);
                });
        });
    };

    static getFileURL = (project: string, id: string, filename: string, mime: string) => {
        filename = encodeURIComponent(filename);
        let url =
            config.api.baseUrl +
            config.api.endpoints["file"] +
            "?org=" +
            org +
            "&project=" +
            project +
            "&id=" +
            id +
            "&filename=" +
            filename +
            "&mime=" +
            mime +
            "&namehint=" +
            btoa(filename) +
            "&tk=" +
            AuthService.getToken();
        return url;
    };

    static getFileContent = (fileUrl: string) => {
        return api(fileUrl, { format: "text" });
    };

    static getFilesList = (projectId: string, id: string, callback?: any) => {
        let url = config.api.endpoints["file"] + "?org=" + org + "&project=" + projectId + "&id=" + id;
        //console.log(`getFilesList: ${url}`);
        return new Promise((resolve, reject) => {
            return api(url, { format: "text" })
                .then((data: any) => {
                    if (callback) {
                        callback(data);
                    }
                    resolve(data);
                })
                .catch((error: any) => {
                    console.error(error);
                    reject(error);
                });
        });
    };

    static getRemoteObjects(objectsIds: any, projectId: string, callback: any) {
        objectsIds = UtilsService.cleanArray(objectsIds);
        //console.log("objectsIds:", objectsIds);
        let pendingEntities = objectsIds.length;
        if (pendingEntities === 0) {
            callback([]);
            return;
        }
        const updatedObjects: any = [];
        objectsIds.forEach((ID: string) => {
            this.getEntity(ID, projectId, (entity: any) => {
                if (entity.error) {
                    pendingEntities--;
                    if (pendingEntities === 0) {
                        //console.log("*****done retrieving remote Objects:", updatedObjects);
                        callback(updatedObjects);
                    }
                    return;
                }
                updatedObjects.push(entity);
                let type = "entities";
                if (entity["type"] === "PROJECT") {
                    type = "projects";
                } else if (entity["view_type"] === "container") {
                    updateEntityToCache("views", projectId, entity);
                }
                updateEntityToCache(type, projectId, entity);
                pendingEntities--;
                if (pendingEntities === 0) {
                    //console.log("*****done retrieving remote Objects:", updatedObjects);
                    callback(updatedObjects);
                }
            });
        });
    }

    static activateVersion(
        projectId: string,
        productId: string,
        versionId: string,
        versionLast: number,
        callback?: any
    ) {
        const body_product = {
            version_active: versionId,
            version_last: versionLast,
        };
        const body_version = {
            version_active_date: new Date().valueOf() + "",
        };
        api(`${config.api.endpoints["entity"]}?id=` + productId + "&project=" + projectId, { body: body_product })
            .then((entries: any) => {
                api(`${config.api.endpoints["entity"]}?id=` + versionId + "&project=" + projectId, {
                    body: body_version,
                })
                    .then((entries: any) => {
                        if (callback) {
                            callback();
                        }
                    })
                    .catch((error: any) => {});
            })
            .catch((error: any) => {});
    }
}
